
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M7.354 5.146a.5.5 0 010 .708l-2 2a.5.5 0 01-.708 0l-1-1a.5.5 0 11.708-.708L5 6.793l1.646-1.647a.5.5 0 01.708 0zM7.354 10.854a.5.5 0 00-.708-.708L5 11.793l-.646-.647a.5.5 0 00-.708.708l1 1a.5.5 0 00.708 0l2-2zM8.5 6.5A.5.5 0 019 6h5a.5.5 0 010 1H9a.5.5 0 01-.5-.5zM14 11H9a.5.5 0 000 1h5a.5.5 0 000-1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 2a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1H2zm14 1H2v12h14V3z"}})])])
          )
        }
      }
    